// @deprecated notions qui n'existe plus
//TODO: A supprimer
export enum TransportTypology {
  ALL = 'ALL',
  GENERAL_GOODS = 'GENERAL_GOODS',
  CONTROLLED_TEMPERATURE = 'CONTROLLED_TEMPERATURE',
  HAZARDOUS_MATERIAL = 'HAZARDOUS_MATERIAL',
  LIVING_ANIMALS = 'LIVING_ANIMALS',
  EXCEPTIONAL_TRANSPORT = 'EXCEPTIONAL_TRANSPORT',
  BULK_TRANSPORT = 'BULK_TRANSPORT',
}
